"use client";

import { useStore } from "@nanostores/react";
import { atom } from "nanostores";

import type { TCatalogueItem } from "./types/catalogue-item";

export interface CatalogueItemLookup {
  name: string;
  type: TCatalogueItem["type"];
}

// ID → { name, type } lookup map
export const catalogueItemsStore = atom<Record<string, CatalogueItemLookup>>(
  {},
);

/**
 * Populate the store from an array of catalogue items.
 * Called by FetchCatalogueItems when data loads.
 */
export const setCatalogueItems = (
  items: Pick<TCatalogueItem, "_id" | "name" | "type">[],
) => {
  const map: Record<string, CatalogueItemLookup> = {};
  for (const item of items) {
    map[item._id] = { name: item.name, type: item.type };
  }
  catalogueItemsStore.set(map);
};

export const useCatalogueItems = () => useStore(catalogueItemsStore);
